// components/NewOrderSelector/components/Summary/Summary.tsx

import React from 'react';
import { Button } from 'react-bootstrap';
import { HiOutlineExclamationTriangle, HiOutlineCheck, HiOutlinePencilSquare } from 'react-icons/hi2';
import './Summary.scss'; // Import the SCSS file
import { formatCurrency } from '../../../../../../../../../../../utils/functions';


interface SummaryProps {
  totalPrice: number;
  handleAddToCart: () => void;
  isEditing: boolean;
  isDisabled: boolean; // New prop to disable the button
}

const Summary: React.FC<SummaryProps> = ({
  totalPrice,
  handleAddToCart,
  isEditing,
  isDisabled,
}) => {
  return (
    <div className="summary-container">
      {isDisabled && (
        <div className="validation-warning">
          <HiOutlineExclamationTriangle className="warning-icon" />
          <span className="warning-text">
            Por favor, completa todas las selecciones requeridas.
          </span>
        </div>
      )}
      
      <div className="total-price-display">
        <span className="total-label">Total:</span>
        <span className="total-amount">{formatCurrency(totalPrice)}</span>
      </div>

      <Button
        variant="none"
        onClick={handleAddToCart}
        className="summary-add-to-cart-button mediopunto-orange-button"
        aria-label={isEditing ? 'Guardar Cambios' : 'Guardar'}
        disabled={isDisabled}
        translate="no"
      >
        {isEditing ? (
          <>
            <HiOutlinePencilSquare className="button-icon" />
            <span translate="no">Guardar Cambios</span>
          </>
        ) : (
          <>
            <HiOutlineCheck className="button-icon" />
            <span translate="no">Guardar</span>
          </>
        )}
      </Button>
    </div>
  );
};

export default Summary;
